import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { CalendarRoutingModule } from './calendar-routing.module';
import { CalendarCellComponent } from './components/calendar-cell/calendar-cell.component';
import { CalendarHeaderDateComponent } from './components/calendar-header-date/calendar-header-date.component';
import { ConflictingEventsComponent } from './components/dialog-conflicting-events/dialog-conflicting-events.component';
import { PricePreviewComponent } from './components/price-preview/price-preview.component';
import { SidebarPricingComponent } from './components/sidebar-pricing/sidebar-pricing.component';
import { SidebarReservationComponent } from './components/sidebar-reservation/sidebar-reservation.component';
import { SidebarTasksComponent } from './components/sidebar-tasks/sidebar-tasks.component';
import { SourceLabelComponent } from './components/source-label/source-label.component';
import { CalendarLandingComponent } from './pages/calendar-landing/calendar-landing.component';
import { MultiCalendarComponent } from './pages/multi-calendar/multi-calendar.component';
import { PropertyCalendarComponent } from './pages/property-calendar/property-calendar.component';
import { ContainsSourcePipe } from './pipes/contains-source.pipe';
import { EventOffsetPipe } from './pipes/event-offset.pipe';
import { FriendlySourceLabelPipe } from './pipes/friendly-source-label.pipe';
import { FriendlySourceTooltipPipe } from './pipes/friendly-source-tooltip.pipe';
import { FriendlySourceTypePipe } from './pipes/friendly-source-type.pipe';
import { LiteCalReservationHeightOffsetPipe } from './pipes/lite-cal-reservation-height-offset.pipe';
import { LiteCalReservationLengthOffsetPipe } from './pipes/lite-cal-reservation-length-offset.pipe';
import { PriceForDayPipe } from './pipes/price-for-day.pipe';
import { PropertyCalEventWidthPipe } from './pipes/property-cal-event-width';
import { IsManualBlockPipe } from './pipes/is-manual-block.pipe';
import { DynamicPricingActivateModalComponent } from '@app/modules/calendar/components/dynamic-pricing-activate-modal/dynamic-pricing-activate-modal.component';
import { SidebarPropertySettingsComponent } from '@app/modules/calendar/components/sidebar-property-settings/sidebar-property-settings.component';
import { DynamicPriceDailyBreakdownComponent } from './components/dynamic-price-daily-breakdown/dynamic-price-daily-breakdown.component';
import { IsPriceManualSourcePipe } from '@app/features/pricing-and-availability';
import { DynamicPricingSidebarBreakdownComponent } from '@app/modules/calendar/components/dynamic-pricing-sidebar-breakdown/dynamic-pricing-sidebar-breakdown.component';

@NgModule({
  declarations: [
    PropertyCalEventWidthPipe,
    PriceForDayPipe,
    LiteCalReservationHeightOffsetPipe,
    LiteCalReservationLengthOffsetPipe,
    CalendarLandingComponent,
    MultiCalendarComponent,
    PropertyCalendarComponent,
    PricePreviewComponent,
    SidebarPricingComponent,
    SidebarReservationComponent,
    SidebarTasksComponent,
    ContainsSourcePipe,
    FriendlySourceLabelPipe,
    FriendlySourceTooltipPipe,
    FriendlySourceTypePipe,
    SourceLabelComponent,
    CalendarCellComponent,
    CalendarHeaderDateComponent,
    EventOffsetPipe,
    ConflictingEventsComponent,
  ],
  imports: [
    CommonModule,
    CalendarRoutingModule,
    SharedModule,
    IsManualBlockPipe,
    SidebarPropertySettingsComponent,
    DynamicPricingActivateModalComponent,
    DynamicPriceDailyBreakdownComponent,
    IsPriceManualSourcePipe,
    DynamicPricingSidebarBreakdownComponent
  ],
  providers: [FriendlySourceLabelPipe, FriendlySourceTypePipe],
})
export class CalendarModule {}
